// Ported from vendor-ref/mara/app/ui/src/main.js: Pinia, PrimeVue Aura preset via MARA's theme, ripple,
// darkModeSelector '.dark', UnoCSS. Shared by the site (main.ts) and the ChatGPT widget (widget/main.ts).
import type { App } from 'vue';
import { createPinia } from 'pinia';
import PrimeVue from 'primevue/config';
import ConfirmationService from 'primevue/confirmationservice';
import ToastService from 'primevue/toastservice';
import Ripple from 'primevue/ripple';
import Tooltip from 'primevue/tooltip';
import 'virtual:uno.css';
import './assets/main.css';
import Theme from './theme';

export function installPlugins(app: App): App {
  app.use(createPinia());
  app.use(PrimeVue, {
    theme: {
      preset: Theme,
      options: {
        prefix: '',
        darkModeSelector: '.dark',
        cssLayer: { name: 'primevue', order: 'primevue, utilities' },
      },
    },
    ripple: true,
  });
  app.use(ConfirmationService);
  app.use(ToastService);
  app.directive('ripple', Ripple);
  app.directive('tooltip', Tooltip);
  return app;
}
